<template>
  <div>

    <ed-table
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      disableCheckAll
      disabledConfigCell
      disableInputSearch
    />
  </div>
</template>

<script>

import EdTable from 'common/table'

export default {
    name: 'EmpresaCadastro',
    components:{EdTable},
    mixins:[],
    props:{
    id_ghe:{
      type: Number,
      default:null
    },
  },
  watch:{
    id_ghe(){
      this.getPCMSO()
    },
  },

  data () {
    return{
      formData:{
        pcmso:null,
      },
      pagination:{},
      response:{},
      tableData:[],
      tableHead:[
        {
          key: 'exame',
          sortable: true,
          label: 'Exame',
        },
        {
          key: 'adm',
          sortable: true,
          show_html:true,
          label: 'Admissional',
        },
        {
          key: 'apos_adm',
          sortable: true,
          show_html:true,
          label: 'Após Admissional',
        },
        {
          key: 'dem',
          sortable: true,
          show_html:true,
          label: 'Demissional',
        },
        {
          key: 'ret_tra',
          sortable: true,
          show_html:true,
          label: 'Retorno ao Trabalho',
        },
        {
          key: 'mud_fun',
          sortable: true,
          show_html:true,
          label: 'Mudança de Função',
        },
        {
          key: 'periodicidade',
          sortable: true,
          show_html:true,
          label: 'Periódico',
        },
        {
          key: 'validade',
          sortable: true,
          show_html:true,
          label: 'Validade do Exame',
        },
      ],
      showModal:false,
      loadingTable:false,
    }
  },
  beforeDestroy(){
		this.tableData = [];
	},
  created(){
  },
  mounted(){
    this.getPCMSO()
  },

  methods: {

    getPCMSO(){

      if(!this.id_ghe)return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};
      this.$root.$session.pcmso = null;

      this.$root.$request.get('pcmso/ghe/exame/'+this.id_ghe).then((result) =>{

        this.response = result;
        this.loadingTable = false;

        var data = [], tableData = [], pagination = {};

        if(result.status == 200){

          data = result.data.data;

          this.$root.$session.pcmso = data;

          for (var i = 0; i < data.length; i++) {
            
            var periodicidade = '';

            if(data[i].periodicidade_a != '0' && data[i].per_id1 != '0'){
              periodicidade += "<span style='color:green'>"+data[i].periodicidade_a+" meses até "+data[i].per_id1+" anos, </span>"
            }

            periodicidade += (data[i].periodicidade != '0' ? '<span style="color:green">'+data[i].periodicidade+' meses</span>' : '<span style="color:red">Não</span>');

            if(data[i].per_id1 != '0'){
              periodicidade += "<span style='color:green'>\nA partir dos "+data[i].per_id1+" anos</span>"
            }

            if(data[i].per_id2 != '0'){
              periodicidade += "<span style='color:green'>\nAté os  "+data[i].per_id2+" anos</span>"
            }

            if(data[i].periodicidade_d != '0' && data[i].per_id2 != '0'){
              periodicidade += "<span style='color:green'>, "+data[i].periodicidade_d+" meses depois dos "+data[i].per_id2+" anos </span>"
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              adm: (data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              apos_adm: (data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              dem: (data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              ret_tra: (data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              mud_fun: (data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              validade: (data[i].validade != 0 ? '<span style="color:green">'+data[i].validade+' dias</span>' : '<span style="color:red">---</span>'),
              periodicidade: periodicidade,
              _data: data[i],
              buttons : []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        this.tableData = tableData;
        this.pagination = pagination;

      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// pcmso.vue?7e71d8c3